import styled from 'styled-components';

export const PayoutsWrapper = styled.div``;
export const PayoutsTableWrapper = styled.div`
    width: 100%;
    overflow: auto;
`;
export const PayoutsTitle = styled.h1`
    margin: 12px 0;
`;